module.exports = __webpack_public_path__ + "static/img/kjxzxqy.782d3060.png";